export const Prices = [
  {
    _id: 0,
    name: "₹100 to 190",
    array: [100, 199],
  },
  {
    _id: 1,
    name: "₹200 to 390",
    array: [200, 390],
  },
  {
    _id: 2,
    name: "₹400 to 590",
    array: [400, 599],
  },
  {
    _id: 3,
    name: "₹600 to 790",
    array: [600, 799],
  },
  {
    _id: 4,
    name: "₹800 to 990",
    array: [800, 999],
  },
  {
    _id: 4,
    name: "₹1000 or more",
    array: [1000, 99999],
  },
];
